import { render, staticRenderFns } from "./AddonProgrammeMISFeeReport.vue?vue&type=template&id=a1b228d2&scoped=true"
import script from "./AddonProgrammeMISFeeReport.vue?vue&type=script&lang=js"
export * from "./AddonProgrammeMISFeeReport.vue?vue&type=script&lang=js"
import style0 from "./AddonProgrammeMISFeeReport.vue?vue&type=style&index=0&id=a1b228d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b228d2",
  null
  
)

export default component.exports